import { Button, MenuTrigger, Tooltip } from '@fluentui/react-components';
import React from 'react';
import { ActionMenuIcon } from './ActionMenuIcon';
import { useActionMenuTriggerStyles } from './ActionMenuTrigger.styles';
export var ActionMenuTrigger = function (_a) {
    var ariaLabel = _a.ariaLabel, icon = _a.icon, tooltip = _a.tooltip, disabled = _a.disabled, onClickCallback = _a.onClickCallback;
    var styles = useActionMenuTriggerStyles();
    if (!icon && !tooltip && !ariaLabel) {
        return null;
    }
    var trigger = (React.createElement(MenuTrigger, null,
        React.createElement(Button, { "aria-label": ariaLabel, appearance: "transparent", className: styles.button, icon: icon && (React.createElement(ActionMenuIcon, { icon: icon, className: styles.icon, isDisabled: disabled })), onClick: function (e) {
                e.stopPropagation();
                e.preventDefault();
                if (onClickCallback && !disabled) {
                    onClickCallback();
                }
            }, size: "small" })));
    if (tooltip) {
        return (React.createElement(Tooltip, { content: tooltip, relationship: "description" }, trigger));
    }
    return trigger;
};
//# sourceMappingURL=ActionMenuTrigger.js.map